(function() {
    const pathSegments = window.location.pathname.split('/');
    const possibleLang = pathSegments[1]?.toLowerCase();
    
    const supportedLangs = ['es', 'en', 'fr', 'it', 'de'];
    const targetLang = supportedLangs.includes(possibleLang) ? possibleLang : 'en';

    const formTranslations = {
        es: {
            "Get in touch for bulk enquiries": "Póngase en contacto para consultas al por mayor",
            "Have questions or need custom rope solutions for your industry? Our team is here to help you choose the safest, most reliable products for your needs.": "¿Tiene preguntas o necesita soluciones de cuerdas personalizadas para su industria? Nuestro equipo está aquí para ayudarle a elegir los productos más seguros y fiables para sus necesidades.",
            "Thank you! The form was submitted successfully.": "¡Gracias! El formulario se envió correctamente.",
            "First Name": "Nombre",
            "Last Name": "Apellido",
            "Email*": "Correo electrónico*",
            "Email": "Correo electrónico",
            "Phone*": "Teléfono*",
            "Phone": "Teléfono",
            "Message*": "Mensaje*",
            "Message": "Mensaje",
            "Submit": "Enviar"
        },
        fr: {
            "Get in touch for bulk enquiries": "Contactez-nous pour les demandes en gros",
            "Have questions or need custom rope solutions for your industry? Our team is here to help you choose the safest, most reliable products for your needs.": "Vous avez des questions ou besoin de solutions de cordes sur mesure pour votre industrie ? Notre équipe est là pour vous aider à choisir les produits les plus sûrs et les plus fiables pour vos besoins.",
            "Thank you! The form was submitted successfully.": "Merci ! Le formulaire a été soumis avec succès.",
            "First Name": "Prénom",
            "Last Name": "Nom de famille",
            "Email*": "E-mail*",
            "Email": "E-mail",
            "Phone*": "Téléphone*",
            "Phone": "Téléphone",
            "Message*": "Message*",
            "Message": "Message",
            "Submit": "Soumettre"
        },
        it: {
            "Get in touch for bulk enquiries": "Contattaci per richieste all'ingrosso",
            "Have questions or need custom rope solutions for your industry? Our team is here to help you choose the safest, most reliable products for your needs.": "Hai domande o necessiti di soluzioni su misura in corda per il tuo settore? Il nostro team è qui per aiutarti a scegliere i prodotti più sicuri e affidabili per le tue esigenze.",
            "Thank you! The form was submitted successfully.": "Grazie! Il modulo è stato inviato con successo.",
            "First Name": "Nome",
            "Last Name": "Cognome",
            "Email*": "Email*",
            "Email": "Email",
            "Phone*": "Telefono*",
            "Phone": "Telefono",
            "Message*": "Messaggio*",
            "Message": "Messaggio",
            "Submit": "Invia"
        },
        de: {
            "Get in touch for bulk enquiries": "Kontaktieren Sie uns für Großanfragen",
            "Have questions or need custom rope solutions for your industry? Our team is here to help you choose the safest, most reliable products for your needs.": "Haben Sie Fragen oder benötigen Sie maßgeschneiderte Seillösungen für Ihre Branche? Unser Team hilft Ihnen gerne bei der Auswahl der sichersten und zuverlässigsten Produkte für Ihre Anforderungen.",
            "Thank you! The form was submitted successfully.": "Vielen Dank! Das Formular wurde erfolgreich gesendet.",
            "First Name": "Vorname",
            "Last Name": "Nachname",
            "Email*": "E-Mail*",
            "Email": "E-Mail",
            "Phone*": "Telefon*",
            "Phone": "Telefon",
            "Message*": "Nachricht*",
            "Message": "Nachricht",
            "Submit": "Absenden"
        }
    };

    if (!formTranslations[targetLang] || targetLang === 'en') return;

    const dictionary = formTranslations[targetLang];

    function traverseAndTranslate(node) {
        if (node.nodeType === 3) { 
            let text = node.nodeValue.trim();
            if (text && dictionary[text]) {
                node.nodeValue = node.nodeValue.replace(text, dictionary[text]);
            }
        } 
        else if (node.nodeType === 1) { 
            if (['script', 'style'].includes(node.tagName.toLowerCase())) return;

            ['aria-label', 'placeholder', 'aria-placeholder', 'name'].forEach(attr => {
                if (node.hasAttribute(attr)) {
                    let attrVal = node.getAttribute(attr).trim();
                    if (dictionary[attrVal]) {
                        node.setAttribute(attr, dictionary[attrVal]);
                    }
                }
            });
            
            for (let i = 0; i < node.childNodes.length; i++) {
                traverseAndTranslate(node.childNodes[i]);
            }
        }
    }

    setInterval(() => {
        if (document.body) {
            traverseAndTranslate(document.body);
        }
    }, 500); 
})();